import { css } from 'styled-components';

/** Slim WebKit scrollbar used by scrollable panels. */
export const thinScrollbar = css`
    &::-webkit-scrollbar {
        width: 5px;
        height: 5px;
        border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: rgba(0, 0, 0, 0.2);
    }

    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.25);
    }
`;
